import React from 'react';

const Sparkline = ({ data = [], color = 'var(--accent)' }) => {
    if (!data.length) return null;
    const w = 76;
    const h = 28;
    const pad = 2;
    const max = Math.max(...data);
    const min = Math.min(...data);
    const range = max - min || 1;
    const step = data.length > 1 ? (w - pad * 2) / (data.length - 1) : 0;
    const pts = data.map((v, i) => [pad + i * step, h - pad - ((v - min) / range) * (h - pad * 2)]);
    const d = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' ');
    const area = `${d} L ${pts[pts.length - 1][0]} ${h} L ${pts[0][0]} ${h} Z`;
    return (
        <svg className="spark" viewBox={`0 0 ${w} ${h}`} fill="none">
            <path d={area} fill={color} opacity="0.12" />
            <path d={d} stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default Sparkline;
